<template>
    <v-dialog width="1000" v-model="isOpenCredentialsSummary" persistent>
        <v-card style="width: 100% !important">
            <v-card-title>
                <v-row>
                    <v-col class="d-flex justify-center" cols="9">
                        <h3 class="font-weight-light primary--text">
                            Credenciales
                        </h3>
                    </v-col>
                    <v-col cols="3">
                        <v-btn
                            depressed
                            @click="openCreate()"
                            color="green darken-2"
                            outlined
                            dark
                            small
                            class="d-flex justify-end"
                        >
                            Crear Credenciales
                            <v-icon right>mdi-lock-plus</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card elevation="0" class="pa-4">
                <v-data-table
                    :headers="headers"
                    :items="credentials"
                    class="elevation-0"
                    :search="search"
                    :footer-props="footer_props"
                >
                    <template v-slot:top>
                        <v-text-field
                            v-model="search"
                            label="Buscar"
                            class="mx-4"
                        ></v-text-field>
                    </template>
                    <template v-slot:item.created_on="{ item }">
                        {{ formatDate(item.created_on) }}
                    </template>
                    <template v-slot:item.Actions="{ item }">
                        <v-col md="12">
                            <div class="d-flex flex-row justify-space-between">
                                <v-btn
                                    v-if="hasSuperAdminPermission"
                                    fab
                                    @click="openEdit(item)"
                                    x-small
                                    color="orange"
                                    outlined
                                >
                                    <v-icon> mdi-pen </v-icon>
                                </v-btn>
                                <v-btn
                                    v-if="hasSuperAdminPermission"
                                    class="ml-1"
                                    fab
                                    @click="openDeleteDialog(item)"
                                    x-small
                                    color="red"
                                    outlined
                                >
                                    <v-icon> mdi-delete </v-icon>
                                </v-btn>
                            </div>
                        </v-col>
                    </template>
                </v-data-table>
            </v-card>
            <v-card-actions elevation="0" class="justify-end mt-n8">
                <v-btn
                    text
                    color="red"
                    @click="isOpenCredentialsSummary = false"
                >
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
        <CredentialsForm />
    </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { clone, objectSnakeToCamelCase } from '@/util/libUtil.js';
import CredentialsForm from '@/components/RRHH/Credentials/CredentialsForm.vue';

export default {
    data: () => ({
        search: '',
        date: new Date().toISOString().substr(0, 7),
        menu: false,
        modal: false,
        headers: [
            {
                text: 'Portal',
                value: 'nombre_portal',
                align: 'start',
            },
            {
                text: 'URL',
                value: 'url',
                align: 'start',
            },
            {
                text: 'Usuario',
                value: 'username',
                align: 'start',
            },
            {
                text: 'Acciones',
                value: 'Actions',
                align: 'center',
                sortable: false,
                width: '10px',
            },
        ],
        footer_props: {
            disableItemsPerPage: true,
            itemsPerPageOptions: [10],
        },
    }),
    components: {
        CredentialsForm,
    },
    computed: {
        isOpenCredentialsSummary: {
            get() {
                return this.$store.state.rrhh.credentials.isOpen;
            },
            set(value) {
                this.$store.commit('rrhh/isOpenCredentialsSummary', value);
            },
        },
        ...mapState('rrhh', {
            credentials: (state) => state.credentials.credentials,
        }),
        ...mapGetters('login', {
            hasSuperAdminPermission: 'hasSuperAdminPermission',
        }),
    },
    methods: {
        formatDate(date) {
            return new Date(date).toISOString().substr(0, 7);
        },
        openEdit(item) {
            item.cookie = JSON.stringify(item.cookie);
            this.$store.commit('rrhh/credentialsForm', item);
            this.$store.commit('rrhh/credentialsType', 'EDIT');
            this.$store.commit('rrhh/isOpenCredentialsView', true);
        },
        openCreate() {
            this.$store.commit('rrhh/credentialsType', 'CREATE');
            this.$store.commit('rrhh/isOpenCredentialsView', true);
        },
        searchNewDate() {
            let params = {
                created_on: this.date,
            };
            if (new Date(this.date) >= this.dateActualInmutable) {
                params = { ...params, is_active: true };
            }
            this.getcredentials(params);
        },
        openDeleteDialog(item) {
            let deleteObj = {
                toDeleteId: item.id,
                toDeleteType: 'CREDENTIALS',
                isOpenDeleteDialog: true,
            };

            this.$store.commit('util/deleteDialog', clone(deleteObj));
        },
        ...mapActions('rrhh', ['getCredentials']),
    },
    watch: {},
};
</script>

<style>
.lighten-red-bg {
    background-color: #ffcdd2 !important;
}
.lighten-orange-bg {
    background-color: #fdcb81 !important;
}
.lighten-yellow-bg {
    background-color: #f9ff9e !important;
}
</style>







